import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { InspectorToken } from '@sleed/bizcommerce-api';
import { inspectorsApi } from '~/lib/api/client';
import { formToToken, type InspectorFormValues } from '~/lib/schemas/inspector';

export const inspectorKeys = {
	all: ['inspectors'] as const,
	list: () => [...inspectorKeys.all, 'list'] as const
};

/** All inspectors (client-side grid; legacy loads the full set via GetAll). */
export function useInspectorsList() {
	return useQuery<InspectorToken[]>({
		queryKey: inspectorKeys.list(),
		queryFn: async () => (await inspectorsApi.getAll()).data.items ?? []
	});
}

export function useInspectorMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: inspectorKeys.all });
	const create = useMutation({
		mutationFn: async (form: InspectorFormValues) => (await inspectorsApi.insert(formToToken(form, null))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async ({ form, original }: { form: InspectorFormValues; original: InspectorToken | null }) =>
			(await inspectorsApi.update(formToToken(form, original))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await inspectorsApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
